"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const _ = require("lodash");
const proj4js = require("proj4");
const mgrs = require("mgrs");
const proj4 = proj4js.default;
// const proj4 = proj4js;
exports.PUGW92 = "EPSG:2180";
exports.WEB_MERCATOR = "EPSG:3857";
exports.WGS84 = 'EPSG:4326';
function setupProjections() {
    proj4.defs(exports.PUGW92, "+proj=tmerc +lat_0=0 +lon_0=19 +k=0.9993 +x_0=500000 +y_0=-5300000 +ellps=GRS80 +units=m +no_defs");
    return proj4;
}
exports.setupProjections = setupProjections;
/**
 * @param {number[2]} puwg
 */
function puwg2ll(puwg) {
    return proj4cache.get(exports.PUGW92, exports.WGS84).forward(puwg);
}
exports.puwg2ll = puwg2ll;
function ll2pugw(puwg) {
    return proj4cache.get(exports.PUGW92, exports.WGS84).inverse(puwg);
}
exports.ll2pugw = ll2pugw;
function utmZone(latLon) {
    return 1 + Math.floor((latLon[0] + 180) / 6);
}
exports.utmZone = utmZone;
function utmZoneWM(c /*WEB_MERCATOR*/) {
    const latLon = ol.proj.transform(c, exports.WEB_MERCATOR, exports.WGS84);
    return 1 + Math.floor((latLon[0] + 180) / 6);
}
exports.utmZoneWM = utmZoneWM;
const proj4cache = new class Proj4Cache {
    constructor() {
        this.cache = {};
    }
    get(proj1, proj2) {
        const cachePath = [proj1, proj2];
        const cached = _.get(this.cache, cachePath);
        if (cached === undefined) {
            console.log(`new proj4 [${proj1}]->[${proj2}]`);
            const fresh = proj4(proj1, proj2);
            _.set(this.cache, cachePath, fresh);
            return fresh;
        }
        else {
            return cached;
        }
    }
};
/**
 * @deprecated
 * @param {number[2]} latLon
 */
function ll2utm(zone, latLon) {
    return proj4cache.get(exports.WGS84, "+proj=utm +zone=" + zone + " +north +ellps=WGS84 +datum=WGS84 +units=m +no_defs")
        .forward(_.clone(latLon));
}
exports.ll2utm = ll2utm;
function webmercator2utm(zone, c) {
    return proj4cache.get(exports.WEB_MERCATOR, "+proj=utm +zone=" + zone + " +north +ellps=WGS84 +datum=WGS84 +units=m +no_defs")
        .forward(_.clone(c));
}
exports.webmercator2utm = webmercator2utm;
function webmercator2ll(c) {
    return proj4cache.get(exports.WEB_MERCATOR, exports.WGS84).forward(_.clone(c));
}
exports.webmercator2ll = webmercator2ll;
function utm2webmercator(zone, utm) {
    return proj4cache.get("+proj=utm +zone=" + zone + " +north +ellps=WGS84 +datum=WGS84 +units=m +no_defs", exports.WEB_MERCATOR)
        .forward(_.clone(utm));
}
exports.utm2webmercator = utm2webmercator;
/**
 * @deprecated
 */
function utm2ll(zone, utm) {
    return proj4cache.get("+proj=utm +zone=" + zone + " +north +ellps=WGS84 +datum=WGS84 +units=m +no_defs", exports.WGS84)
        .forward(_.clone(utm));
}
exports.utm2ll = utm2ll;
function utm2puwg(zone, utm) {
    return proj4cache.get("+proj=utm +zone=" + zone + " +north +ellps=WGS84 +datum=WGS84 +units=m +no_defs", exports.PUGW92)
        .forward(_.clone(utm));
}
exports.utm2puwg = utm2puwg;
function puwg2utm(zone, puwg) {
    return proj4cache.get(exports.PUGW92, "+proj=utm +zone=" + zone + " +north +ellps=WGS84 +datum=WGS84 +units=m +no_defs")
        .forward(_.clone(puwg));
}
exports.puwg2utm = puwg2utm;
function utm2mgrs(zone, utm) {
    const ll = utm2ll(zone, utm);
    return ll2mgrs([ll.x, ll.y]);
}
exports.utm2mgrs = utm2mgrs;
function ll2mgrs(ll) {
    const mgrsString = mgrs.forward(ll);
    const result = /(...)(..)(.....)(.....)/.exec(mgrsString);
    return {
        zone: result[1],
        grid: result[2],
        x: result[3],
        y: result[4]
    };
}
exports.ll2mgrs = ll2mgrs;
function mgrs2webmercator(c) {
    const ll = mgrs.toPoint(c);
    return proj4cache.get(exports.WEB_MERCATOR, exports.WGS84).inverse(ll);
}
exports.mgrs2webmercator = mgrs2webmercator;



//////////////////
// WEBPACK FOOTER
// ./src/logic/proj4defs.ts
// module id = 34
// module chunks = 0 1